import { useEffect, useState } from 'react'
import { useGetAuthenticatedUser } from 'Flux/Selector/index.js'
import {
  organizationOverrideOf,
  overrideEntitlementSummary,
  overrideRemainingTimeLabel
} from 'Model/User/organizationOverride.js'
import { useModal } from '../../Modal/UseModal.js'

const TICK_INTERVAL_MS = 60_000

/**
 * An override makes every licence verdict describe another organization. Without a standing indicator
 * an operator reads those verdicts as their own — which is how S2-1052 was verified against the wrong
 * organization.
 */
export const OrganizationOverrideIndicator = () => {
  const override = organizationOverrideOf(useGetAuthenticatedUser())
  const { openModal } = useModal()
  /* Forces a re-render each minute so the remaining-time label counts down without a page reload. */
  const [, tick] = useState(0)

  useEffect(() => {
    if (!override?.expiresAt) return
    const id = setInterval(() => tick((n) => n + 1), TICK_INTERVAL_MS)
    return () => clearInterval(id)
  }, [override?.expiresAt])

  if (!override) return null

  const remaining = overrideRemainingTimeLabel(override)

  return (
    <button
      type="button"
      data-testid="organization-override-indicator"
      className="flex items-center alert alert-warning py-2 px-3 text-left"
      title="Open admin tools"
      onClick={() => openModal('markusAdmin', {})}
    >
      <span>
        Admin override: acting as <b>{override.targetOrganizationName ?? override.targetOrganizationId}</b> with{' '}
        {overrideEntitlementSummary(override)}
        {remaining && <> {remaining}</>}
        {!override.targetResolved && override.entitlementSource !== 'UNRESOLVED' && ' (target organization unreadable)'}
      </span>
    </button>
  )
}
